import React, { Component, Fragment } from "react";
import { Slider } from "antd";
import platform from "Pub/js/platform";
import { getMulti } from "Pub/js/getMulti";
import { fontFamilies, fontSizes, MarkType_Text, MarkType_Image, blobToDataURI, StyleType_Global, StyleType_Group, StyleType_App, getWatermarkImageSet } from './common';
import { langCheck } from "Pub/js/utils.js";
import { SketchPicker } from 'react-color';
import WatermarkEditor from './WatermarkEditor';
import './WatermarkSettingPanel.less';

const { toast, getTheme, getAppReqParam } = platform;

const { NCRadio, NCButton, NCSelect, NCCheckbox, NCInputNumber, NCUpload, NCPopover, NCFormControl, NCTooltip } = platform.base;
const { Refer } = platform.high;

function genSysVars(json) {
    return [
        { display: `${langCheck('Watermark-000030', 'pages', json)}`, value: '&[bisdate]' }, // 业务日期 （取右上角业务日期）
        { display: `${langCheck('Watermark-000048', 'pages', json)}`, value: '&[department]' }, // 主职部门 （取当前用户对应人员主职部门）
        { display: `${langCheck('Watermark-000049', 'pages', json)}`, value: '&[personname]' }, // 人员名称
        { display: `${langCheck('Watermark-000034', 'pages', json)}`, value: '&[user]' }, // 用户名称
        { display: `${langCheck('Watermark-000035', 'pages', json)}`, value: '&[userid]' }, // 用户编码
        { display: `${langCheck('Watermark-000036', 'pages', json)}`, value: '&[useremail]' }, // 用户邮箱
        { display: `${langCheck('Watermark-000037', 'pages', json)}`, value: '&[usercell]' }, // 用户手机号
        { display: `${langCheck('Watermark-000038', 'pages', json)}`, value: '&[deftext]' }, // 自定义文本
        { display: `${langCheck('Watermark-000031', 'pages', json)}`, value: '&[clientdate]' }, // 客户端日期 （取用户客户端日期）
        { display: `${langCheck('Watermark-000045', 'pages', json)}`, value: '&[clienttime]' }, // 客户端时间 （取客户端时间（时分秒））
        { display: `${langCheck('Watermark-000043', 'pages', json)}`, value: '&[sysdate]' }, // 系统日期 （取服务器端日期）
        { display: `${langCheck('Watermark-000044', 'pages', json)}`, value: '&[systime]' }, // 系统时间 （取服务器端时间（时分秒））
        { display: `${langCheck('Watermark-000050', 'pages', json)}`, value: '&[group]' }, // 所属集团 （取当前集团名称）
        { display: `${langCheck('Watermark-000033', 'pages', json)}`, value: '&[busiunit]' }, // 人员所属业务单元 （取当前用户对应人员的所属业务单元名称）
    ];
}

class WatermarkSettingPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            json: {},
            sysvars: [],
            disableUseAppPage: null,
            disableUsePrintPage: null
        };
    }

    render() {
        return (
            <div className="watermark-setting-panel">
                <div className="fields-wrap">
                    {this.renderFields()}
                </div>
            </div>
        );
    }

    componentDidMount() {
        getMulti({
            moduleId: 'WatermarkSetting',
            domainName: 'workbench',
            callback: json => {
                this.setState({
                    json,
                    sysvars: genSysVars(json)
                });
            },
        });
    }

    renderFields() {
        const fields = this.initFields();
        return fields.map((item, index) => {
            let { itemtype, visible = true, ...rest } = item;
            if (itemtype === 'title') {
                return visible ? (
                    <div key={`item_${index}`} className="field-title">{rest.label}</div>
                ): null;
            } else if (itemtype === 'label') {
                return visible ? (
                    <div key={`item_${index}`} className={`field-area field-${rest.itemcode}`}>
                        {
                            !rest.hideLabel && (<div className="field-label">{rest.label}</div>)
                        }
                    </div>
                ) : null;
            } else {
                return visible ? (
                    <div 
                        key={`item_${index}`} 
                        className={`field-area field-${rest.itemcode}`}
                        style={this.props.styletype === StyleType_Global ? rest.style : {}}
                    >
                        {
                            !rest.hideLabel && (<div className="field-label">{rest.label}</div>)
                        }
                        <div className="field-item">
                            {this.renderField(item)}
                        </div>
                    </div>
                ) : null;
            }
        });
    }

    renderField(item) {
        const { watermarkSetting } = this.props;
        const { json } = this.state;
        const { itemtype, ...rest } = item;
        const appParams = getAppReqParam();
        const { appcode } = appParams;
        let ret = null;
        
        switch (itemtype) {
            case 'radio':
                ret = (
                    <NCRadio.RadioGroup 
                        selectedValue={watermarkSetting[rest.itemcode]} 
                        name={rest.itemcode} 
                        onChange={value => {
                            let params = [[rest.itemcode, value]];
                            if (rest.itemcode === 'marktype') {
                                params.push(['usewatermark', !!value]);
                            }
                            this.updateWaterMarkSetting(params);
                        }}
                    >
                        <NCRadio value={rest.radio.value} fieldid={`radio-${rest.itemcode}-${rest.radio.value}`}>{rest.radio.display}</NCRadio>
                    </NCRadio.RadioGroup>
                );
                break;
            case 'singleCheck':
                ret = (
                    <SingleCheck
                        name={rest.meta.name}
                        origValue={rest.meta.origValue}
                        label={rest.meta.label}
                        value={watermarkSetting[rest.itemcode]}
                        onChange={(value, itemcode) => {
                            let params = [[rest.itemcode, value]];
                            if (itemcode === 'marktype') {
                                params.push(['usewatermark', !!value]);
                                this.setState({
                                    disableUseAppPage: false,
                                    disableUsePrintPage: false
                                });
                            }
                            this.updateWaterMarkSetting(params);
                        }}
                    />
                );
                break;  
            case 'select':
                ret = (
                    <NCSelect
                        disabled={rest.disabled}
                        value={watermarkSetting[rest.itemcode]}
                        fieldid={`select-${rest.itemcode}`}
                        showClear={false}
                        onChange={value => {
                            this.updateWaterMarkSetting([[rest.itemcode, value]]);
                        }}
                    >
                        {
                            rest.options.map((option, index) => {
                                return (
                                    <NCSelect.Option key={`option_${index}_${option.value}`} value={option.value}>{option.display}</NCSelect.Option>
                                );
                            })
                        }
                    </NCSelect>
                );
                break;
            case 'refer':
                ret = (
                    <Refer
                        disabled={rest.disabled}
                        fieldid={`refer-${rest.itemcode}`}
                        value={watermarkSetting[rest.itemcode]}
                        {...rest}
                        onChange={value => {
                            this.updateWaterMarkSetting([[rest.itemcode, value]]);
                        }}
                    />
                );
                break;
            case 'checkbox':
                ret = (
                    <NCCheckbox fieldid={`checkbox-${rest.itemcode}`}
                        disabled={rest.disabled}
                        checked={watermarkSetting[rest.itemcode]}
                        onChange={value => {
                            this.updateWaterMarkSetting([[rest.itemcode, value]]);
                        }}
                    >{rest.title}</NCCheckbox>
                );
                break;
            case 'slider':
                ret = (
                    <Slider
                        className="subject-setting-slider"
                        fieldid={`slider-${rest.itemcode}`} 
                        value={watermarkSetting[rest.itemcode]}
                        {...rest} 
                        onChange={value => {
                            this.updateWaterMarkSetting([[rest.itemcode, value]]);
                        }}
                    />
                );
                break;
            case 'custom':
                ret = rest.render && rest.render(item);
                // ret = (<div>{rest.itemcode}</div>);
                break;
            case 'upload':
                ret = <Fragment>
                    <NCUpload
                        disabled={rest.disabled}
                        accept='image/png'
                        size={1024 * 200}
                        multiple={false}
                        maxCount="1"
                        // showUploadList={false}
                        // action="/nccloud/platform/attachment/upload.do"
                        // data={{ billId: appcode }}
                        beforeUpload={e => {
                            this.beforeUploadMarkImage(rest.itemcode, e);
                            return false;
                        }}
                        onChange={e => {
                            console.log(e);
                        }}
                    >
                        <NCButton className="upload-button" type="text" disabled={rest.disabled}>
                            <i className="upload-icon  iconfont icon-shangchuan" />
                            {langCheck('Watermark-000028', 'pages', json)}
                            {/* 上传 */}
                        </NCButton>
                    </NCUpload>
                    <NCTooltip
                        placement="bottom"
                        overlay={langCheck('Watermark-000058', 'pages', json)}
                    >
                        <i className="iconfont icon-shuoming1 upload-help-icon" />
                    </NCTooltip>
                </Fragment>;
                break;
            case 'iconswitch':
                ret = (
                    <NCButton
                        className={watermarkSetting[rest.itemcode] ? 'checked' : ''}
                        shape="icon"
                        disabled={rest.disabled}
                        fieldid={`iconswitch-${rest.itemcode}`}
                        onClick={() => {
                            this.updateWaterMarkSetting([[rest.itemcode, !watermarkSetting[rest.itemcode]]]);
                        }}
                    >
                        <i className={`icon iconfont ${watermarkSetting[rest.itemcode] ? rest.checkedIcon : rest.icon} ${watermarkSetting[rest.itemcode] ? rest.checked : ''}`}/>
                    </NCButton>
                );
                break;
            case 'colorpicker':
                // ret = (
                //     <ColorPicker 
                //         disabled={rest.disabled}
                //         className="input-item-content"
                //         color={watermarkSetting[rest.itemcode]}
                //         onChange={value => {
                //             this.updateWaterMarkSetting([[rest.itemcode, value]]);
                //         }}
                //     />
                // );
                ret = (
                    <div className="color-picker-wrap">
                        <NCPopover
                            trigger="click"
                            placement="bottom"
                            content={
                                <div className="color-picker">
                                    <SketchPicker
                                        placeholder={'请选择十六进制色值'}
                                        color={watermarkSetting[rest.itemcode]}
                                        onChange={v => {
                                            this.updateWaterMarkSetting([[rest.itemcode, v.hex]]);
                                        }}
                                    />
                                </div>
                            }
                        >
                            <NCFormControl
                                className="color-picker-input"
                                type="text"
                                value={watermarkSetting[rest.itemcode]}
                                readonly
                                disabled={rest.disabled}
                            
                            />
                            <div
                                className="color-content"
                                onClick={e => {
                                    if (rest.disabled) {
                                        e.stopPropagation();
                                    }
                                }}
                                style={{ backgroundColor: watermarkSetting[rest.itemcode] || '#fff' }}
                            >
                                {
                                    !watermarkSetting[rest.itemcode] && (
                                        <div className="disable-oblique-line" />
                                    )
                                }
                            </div>
                        </NCPopover>
                    </div>
                );
                break;
            default:
                ret = null;
                break;
        }
        return ret;
    }

    initFields() {
        const { json, sysvars, disableUseAppPage, disableUsePrintPage } = this.state;
        const { styletype = StyleType_Global, watermarkSetting, multiLangOptions } = this.props;
        const fields = [
            {
                itemtype: 'title',
                itemcode: 'sourceGroup',
                label: langCheck("Watermark-000003", 'pages', json), // 来源设置
            },
            // {
            //     itemtype: 'radio',
            //     itemcode: 'marktype',
            //     hideLabel: true,
            //     radio: {
            //         display: langCheck("Watermark-000004", 'pages', json), // 文字水印
            //         value: MarkType_Text, 
            //     },
            // },
            {
                itemtype: 'singleCheck',
                itemcode: 'marktype',
                hideLabel: true,
                meta: {
                    name: 'marktype',
                    origValue: MarkType_Text,
                    label: langCheck("Watermark-000004", 'pages', json), // 文字水印
                },
            },
            {
                itemtype: 'custom',
                itemcode: 'marktpl',
                hideLabel: true,
                render: item => {
                    const { json } = this.state;
                    let { watermarkSetting, multiLangOptions, topContainer } = this.props;
                    return (
                        <WatermarkEditor
                            sysvars={sysvars}
                            json={json} 
                            multiLangOptions={multiLangOptions}
                            value={watermarkSetting.marktpl}
                            disabled={watermarkSetting.marktype !== MarkType_Text}
                            onChange={value => {
                                let items = [['marktpl', value]];
                                this.updateWaterMarkSetting(items);
                            }}
                            topContainer={topContainer}
                        />
                    );
                },
            },
            // {
            //     itemtype: 'radio',
            //     itemcode: 'marktype',
            //     hideLabel: true,
            //     radio: { 
            //         display: langCheck("Watermark-000005", 'pages', json), // '图片水印'
            //         value: MarkType_Image, 
            //     },
            // },
            {
                itemtype: 'singleCheck',
                itemcode: 'marktype',
                hideLabel: true,
                meta: {
                    name: 'marktype',
                    origValue: MarkType_Image,
                    label: langCheck("Watermark-000005", 'pages', json), // '图片水印'
                },
            },
            {
                itemtype: 'upload',
                itemcode: 'markimg',
                hideLabel: true,
                disabled: watermarkSetting.marktype !== MarkType_Image,
            },
            {
                itemtype: 'title',
                itemcode: 'formatGroup',
                label: langCheck("Watermark-000006", 'pages', json), // 格式设置
            },
            {
                itemtype: 'select',
                itemcode: 'fontfamily',
                label: langCheck("Watermark-000007", 'pages', json), // 文字
                // hideLabel: true,
                options: fontFamilies,
                disabled: watermarkSetting.marktype === MarkType_Image,
            },
            {
                itemtype: 'select',
                itemcode: 'fontsize',
                label: langCheck("Watermark-000008", 'pages', json), // 字号
                hideLabel: true,
                options: fontSizes,
                disabled: watermarkSetting.marktype === MarkType_Image,
            },
            {
                itemtype: 'colorpicker',
                itemcode: 'fontcolor',
                // label: langCheck("Watermark-000009", json), // 颜色
                label: '',
                // hideLabel: true,
                className: 'icon iconfont icon-wenziyanse',
                disabled: watermarkSetting.marktype === MarkType_Image,
            },
            {
                itemtype: 'iconswitch',
                itemcode: 'fontbold',
                label: langCheck("Watermark-000010", 'pages', json), // 加粗
                hideLabel: true,
                icon: 'icon-zitijiacu',
                checkedIcon: 'icon-zitijiacuxuanzhong',
                checked: 'checked',
                disabled: watermarkSetting.marktype === MarkType_Image,
            },
            {
                itemtype: 'iconswitch',
                itemcode: 'fontitalic',
                label: langCheck("Watermark-000011", 'pages', json), // 斜体
                hideLabel: true,
                icon: 'icon-qingxie',
                checkedIcon: 'icon-qingxiexuanzhong',
                checked: 'checked',
                disabled: watermarkSetting.marktype === MarkType_Image,
            },
            {
                itemtype: 'custom',
                itemcode: 'rotate',
                label: langCheck("Watermark-000012", 'pages', json), // 旋转
                // render: item => {
                //     const { watermarkSetting } = this.state;
                //     return (
                //         <div className="rotate-container">
                //             <NCRadio.RadioGroup
                //                 name="rotate"
                //                 selectedValue={watermarkSetting[item.itemcode]}
                //                 onChange={value => {
                //                     let items = [['rotate', value]];
                //                     // if (value !== 'custom') {
                //                     //     items.push(['customrotate', parseInt(value)]);
                //                     // }
                //                     this.updateWaterMarkSetting(items);
                //                 }}
                //             >
                //                 {
                //                     rotateArr.map((opt, index) => {
                //                         let { rotate, customrotate } = watermarkSetting;
                //                         if (opt.value === 'custom') {
                //                             return (
                //                                 <NCRadio key={`rotate_${index}`} value={opt.value}>
                //                                     {opt.display}
                //                                     <NCInputNumber
                //                                         className="rotate-input"
                //                                         value={customrotate}
                //                                         min={opt.min}
                //                                         max={opt.max}
                //                                         step={opt.step}
                //                                         disabled={rotate !== 'custom'}
                //                                         onChange={value => {
                //                                             this.updateWaterMarkSetting([['customrotate', value]]);
                //                                         }}
                //                                     />
                //                                 </NCRadio>
                //                             );
                //                         }
                //                         return (
                //                             <NCRadio key={`rotate_${index}`} value={opt.value}>{opt.display}</NCRadio>
                //                         );
                //                     })
                //                 }

                //             </NCRadio.RadioGroup>
                //         </div>
                //     );
                // },
                render: item => {
                    const { watermarkSetting } = this.props;
                    return (
                        <div className="rotate-container">
                            <NCInputNumber
                                fieldid="custom-rotate"
                                className="rotate-input"
                                value={watermarkSetting.rotate}
                                min={-360}
                                max={360}
                                step={1}
                                // disabled={rotate !== 'custom'}
                                onChange={value => {
                                    // blur会再次走一遍这里，值没变化阻止掉
                                    if (value === watermarkSetting.rotate) { return; }
                                    this.updateWaterMarkSetting([['rotate', value]]);
                                }}
                            />
                        </div>
                    );
                },
            },
            {
                itemtype: 'slider',
                itemcode: 'opacity',
                label: langCheck("Watermark-000013", 'pages', json), // 透明度
                max: 1,
                min: 0,
                step: 0.01,
                tipFormatter: value => `${langCheck("Watermark-000013", 'pages', json)} ${value}`,
            },
            {
                itemtype: 'slider',
                itemcode: 'density',
                label: langCheck("Watermark-000014", 'pages', json), // 密度
                min: 0,
                max: 200,
                step: 1,
                tipFormatter: value => `${(value / 200 * 100).toFixed(2)}%`,
            },

        ];
        if (styletype !== StyleType_App) {
            fields.push(...[
                {
                    itemtype: 'title',
                    itemcode: 'assignGroup',
                    label: langCheck("Watermark-000015", 'pages', json), // 范围设置
                    // visible: styletype === StyleType_Group,
                    visible: true,
                },
                {
                    itemtype: 'refer',
                    itemcode: 'ref_openapps',
                    label: langCheck("Watermark-000016", 'pages', json), // 节点打开
                    disabled: watermarkSetting.useallapppage,
                    // disabled: disableUseAppPage === null ? !watermarkSetting.usewatermark : watermarkSetting.useallapppage,
                    visible: styletype === StyleType_Group,
                    refName: langCheck('Watermark-000018', 'pages', json), /* 国际化处理： 关联应用编码*/
                    refCode: 'ref_openapps',
                    refType: 'tree',
                    isTreelazyLoad: false,
                    // queryTreeUrl: '/nccloud/platform/appregister/appregref.do',
                    queryTreeUrl: '/nccloud/platform/appregister/menuitemtreerefbygroup.do',
                    extraParam: { pk_group: this.props.pk_group },
                    treeConfig: {
                        code: ['refcode', 'refname'],
                        name: [langCheck("Watermark-000019", 'pages', json), langCheck("Watermark-000020", 'pages', json)], // 编码，名称
                    },
                    // onlyLeafCanSelect: true,
                    defaultIncludeChildren: true,
                    isMultiSelectedEnabled: true,
                    isShowSelected: false,
                    isShowIncludeSon: false
                },
                {
                    itemtype: 'checkbox',
                    itemcode: 'useallapppage',
                    title: langCheck("Watermark-000017", 'pages', json), // 全部
                    label: langCheck("Watermark-000016", 'pages', json), // 节点打开
                    // disabled: !watermarkSetting.usewatermark,
                    // disabled: disableUseAppPage === null ? !watermarkSetting.usewatermark : disableUseAppPage,
                    visible: true,
                    hideLabel: styletype === StyleType_Group,
                    style: styletype === StyleType_Global ? { flex: '0 0 100%' } : {},
                },
                {
                    itemtype: 'refer',
                    itemcode: 'ref_printapps',
                    label: langCheck("Watermark-000021", 'pages', json), // 打印输出
                    disabled: watermarkSetting.useallprintpage,
                    // disabled: disableUsePrintPage === null ? !watermarkSetting.usewatermark : watermarkSetting.useallprintpage,
                    visible: styletype === StyleType_Group,
                    refName: langCheck('Watermark-000018', 'pages', json), /* 国际化处理： 关联应用编码*/
                    refCode: 'ref_printapps',
                    refType: 'tree',
                    isTreelazyLoad: false,
                    // queryTreeUrl: '/nccloud/platform/appregister/appregref.do',
                    queryTreeUrl: '/nccloud/platform/appregister/menuitemtreerefbygroup.do',
                    extraParam: { pk_group: this.props.pk_group },
                    treeConfig: {
                        code: ['refcode', 'refname'],
                        name: [langCheck("Watermark-000019", 'pages', json), langCheck("Watermark-000020", 'pages', json)], // 编码，名称
                    },
                    // onlyLeafCanSelect: true,
                    defaultIncludeChildren: true,
                    isMultiSelectedEnabled: true,
                    isShowSelected: false,
                    isShowIncludeSon: false
                },
                {
                    itemtype: 'checkbox',
                    itemcode: 'useallprintpage',
                    label: langCheck("Watermark-000021", 'pages', json), // 打印输出
                    title: langCheck("Watermark-000017", 'pages', json), // 全部
                    hideLabel: styletype === StyleType_Group,
                    // disabled: !watermarkSetting.usewatermark,
                    // disabled: disableUsePrintPage === null ? !watermarkSetting.usewatermark : disableUsePrintPage,
                    visible: true,
                    style: styletype === StyleType_Global ? { flex: '0 0 100%' } : {},
                },
            ]);
        }
        return fields;
    }

    async beforeUploadMarkImage(itemcode, e) {
        const { topContainer } = this.props;
        const { json } = this.state;
        const imgInfo = await this.checkImageSize(e);
        // console.log(imgInfo);
        if (e.type !== 'image/png') {
            toast({
                content: langCheck('Watermark-000053', 'pages', json), // 上传的图片只支持png,请重新选择!
                color: 'danger',
                container: topContainer
            });
            return;
        }
        if (imgInfo.originWidth > 288 || imgInfo.originHeight > 128) {
            toast({
                content: langCheck('Watermark-000059', 'pages', json), // 上传的图片宽高规格在288pxX128px范围内,请重新选择!
                color: 'danger',
                container: topContainer
            });
            return;
        }
        if (e.size > (200 * 1024)) {
            toast({
                content: langCheck('Watermark-000029', 'pages', json), // 上传的图片大于200K,请重新选择!
                color: 'danger',
                container: topContainer
            });
        } else {
            blobToDataURI(e, dataURI => {
                this.updateWaterMarkSetting([[itemcode, dataURI]]);
            });
        }
    }

    async checkImageSize(e) {
        return new Promise((resolve) => {
            blobToDataURI(e, async dataURI => {
                const imgInfo = await getWatermarkImageSet({markimg: dataURI});
                console.log(imgInfo);
                resolve(imgInfo);
            });
        });
        
    }
    
    validateWatermarkSetting(watermarkSetting) {
        const { topContainer } = this.props;
        const { json } = this.state;
        const { marktype, marktpl, markimg, useallapppage, useallprintpage, ref_openapps = [], ref_printapps = [], rotate, customrotate } = watermarkSetting;
        const hasMarkSet = marktype.length > 0 && (marktpl.length > 0 || !!markimg);
        // 需求变更，如果用户选择了文字水印但未设置具体内容，不允许保存
        if (marktype === MarkType_Text && marktpl.length === 0) {
            toast({
                content: langCheck('Watermark-000022', 'pages', json), // 未设置文字水印内容
                color: 'danger',
            });
            return false;
        }
        if (marktype === MarkType_Text && marktpl.length > 4) {
            toast({
                content: langCheck('Watermark-000042', 'pages', json), // 文字水印模版不超过4个字段
                color: 'danger',
                container: topContainer
            });
            return false;
        }
        // 需求变更，如果用户选择了图片水印但未上传图片，则提示用户“请上传水印图片”
        if (marktype === MarkType_Image && !markimg) {
            toast({
                content: langCheck('Watermark-000023', 'pages', json), // 请上传水印图片
                color: 'danger',
            });
            return false;
        }
        if (!marktype && (useallapppage || useallprintpage ||  ref_openapps.length > 0 || ref_printapps.length > 0)) {
            toast({
                content: langCheck('Watermark-000060', 'pages', json), // 未设置水印时不允许设置范围
                color: 'danger',
            });
            return false;
        }
        // if (hasMarkSet && !useallapppage && ref_openapps.length === 0) {
        //     toast({
        //         content: langCheck('Watermark-000024', 'pages', json), // 请设置需要添加水印的节点
        //         color: 'danger',
        //     });
        //     return false;
        // }
        // if (hasMarkSet && !useallprintpage && ref_printapps.length === 0) {
        //     toast({
        //         content: langCheck('Watermark-000025', 'pages', json), // 请设置需要打印输出水印的节点
        //         color: 'danger',
        //     });
        //     return false;
        // }
        if (hasMarkSet && !useallapppage && !useallprintpage && ref_openapps.length === 0 && ref_printapps.length === 0) {
            toast({
                content: langCheck('Watermark-000024', 'pages', json), // 未设置水印适用范围
                color: 'danger',
                mark: 'watermark-warning',
                container: topContainer
            });

            return false;
        }
        return true;
    }

    updateWaterMarkSetting(items) {
        const { json } = this.state;
        let { watermarkSetting, onChange, multiLangOptions } = this.props;
        let params = Object.fromEntries(items);
        watermarkSetting = { ...watermarkSetting, ...params };
        // formatWatermarkPreviewConfig(watermarkSetting, multiLangOptions).then(watermarkPreviewConfig => {
        //     onChange && onChange(watermarkSetting, watermarkPreviewConfig);
        // });
        onChange && onChange(watermarkSetting);
        
    }
}

function SingleCheck(props) {
    const { name, origValue, value, label, onChange, ...rest } = props;
    return (
        <NCCheckbox
            fieldid={`checkbox-${name}-${value}`}
            checked={origValue === value}
            onChange={v => {
                onChange && onChange(v ? origValue : '', name);
            }}
            {...rest}
        >
            {label}
        </NCCheckbox>
    );
}

export default WatermarkSettingPanel;